import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enJson from '../../locale/en.json';
import frJson from '../../locale/fr.json';
import nlBEJson from '../../locale/nl_BE.json';
import nlNLJson from '../../locale/nl_NL.json';

export const AVAILABLE_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'nl-NL', name: 'Nederlands (NL)' },
  { code: 'nl-BE', name: 'Nederlands (BE)' },
  { code: 'fr', name: 'Français' },
] as const;

export const getCurrentLanguage = () => {
  const savedLanguage = localStorage.getItem('i18nextLng');

  if (
    savedLanguage &&
    AVAILABLE_LANGUAGES.some((lang) => lang.code === savedLanguage)
  ) {
    return savedLanguage;
  }

  return 'nl-NL'; // Default language
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enJson },
      'nl-NL': { translation: nlNLJson },
      'nl-BE': { translation: nlBEJson },
      fr: { translation: frJson },
    },
    lng: getCurrentLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
      format: (value: string, format?: string) => {
        // Handle special formatting if needed
        if (format === 'uppercase') return value.toUpperCase();

        return value;
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
